export default __webpack_public_path__ + "static/media/btn_edit.418a0a19.svg";